import { Spinner } from 'react-bootstrap';
import { useTranslating } from '../hooks/useTr';

const TranslatingIndicator = () => {
  const translating = useTranslating();

  if (!translating) {
    return null;
  }

  return <Spinner animation="border" size="sm" variant="primary" role="status" />;
};

export default TranslatingIndicator;